const BASE_PROMPTS = [
    'Always reply with HTML.',
    'Never reply with HTML tables.',
    'Never reply with Markdown.',
    'Never include URLs if including buttons or links.',
];

const LETTER_PROMPTS = ['Never include any hyperlinks or buttons.'];

export { BASE_PROMPTS, LETTER_PROMPTS };
